import React from "react";
import { bindActionCreators, Dispatch } from "redux";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { connect } from "react-redux";
import { RootState } from "redux/store";
import { getAgentById } from "redux/selector";
import { Content } from "./content";
import * as env from "shared/env";
import { Profile } from "component/shared/profile";
import { ProfileRefresh } from "component/shared/profile-refresh";

interface Props extends PageProps, 
	Router.RouteComponentProps<RouteParams>,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface RouteParams {
	id: string;
}

const getId = (props: Router.RouteComponentProps<RouteParams>) => {
	return parseInt(props.match.params.id);
}

const mapStateToProps = (state: RootState, ownProps: Router.RouteComponentProps<RouteParams>) => {
	const id = getId(ownProps);
	const agent = getAgentById(state, id);
	return {
		agent,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

class Component extends React.Component<Props> {

	public render() {
		const { user, agent } = this.props;
		const title = "Settings";
		return (
			<DashboardLayout
				permitted={user && user.permissions.broker}
				title={title}
				header={
					// The refreshed detail view (MAX-3707) has no page header per the design — it leads
					// with the "Back to Team" link. Keep the legacy header for the non-refresh path.
					env.refreshTeam ? undefined : (
						<Mui.Typography variant="h1">
							<FeatherIcon>
								<Icons.Settings />
							</FeatherIcon>
							{title}
						</Mui.Typography>
					)
				}
			>
				{agent ? (
					env.refreshTeam ? <ProfileRefresh agent={agent} /> : <Profile agent={agent} />
				) : null}

			</DashboardLayout>
		);
	}

}

export const SettingsAgentPage = connect(mapStateToProps, mapDispatchToProps)(Component);